import { GameCategory } from '@infinitro/catalog-min';
import { FeatureSet, stateTheme, Theme } from '@infinitro/config';
import { Verbiage } from '@infinitro/content';
import { get } from 'svelte/store';
//TODO: Consolidate ordering logic, maybe move to config or something
const sections = [
    {
        id: 'all-games',
        name: Verbiage.all_games,
        icon: 'MobileCasinoIcon',
        sidebarOrder: 0,
        href: GameCategory.All,
        onlySearch: true
    },
    {
        name: Verbiage.originals_fomoio,
        icon: 'OriginalsIcon',
        sidebarOrder: 9,
        href: GameCategory.Originals,
        themes: [Theme.Fomo]
    },
    {
        name: Verbiage.originals,
        icon: 'OriginalsIcon',
        sidebarOrder: 10,
        sidebarOrderByTheme: {
            [Theme.Rocketbet]: 0
        },
        href: GameCategory.Originals,
        themes: [Theme.Flush, Theme.Rocketbet]
    },
    {
        name: Verbiage.popular_games,
        icon: 'PopularIcon',
        sidebarOrder: 11,
        href: GameCategory.Popular,
        themes: [Theme.Flush, Theme.Fomo, Theme.FomoEU, Theme.Luna]
    },
    {
        name: Verbiage.popular,
        icon: 'PopularIcon',
        sidebarOrder: 1,
        href: GameCategory.Popular,
        themes: [Theme.Rocketbet]
    },
    {
        name: Verbiage.slots,
        icon: 'SlotsIcon',
        sidebarOrder: 12,
        sidebarOrderByTheme: {
            [Theme.Rocketbet]: 5
        },
        href: GameCategory.Slots
    },
    {
        name: Verbiage.live_casino,
        icon: 'LiveCasinoIcon',
        sidebarOrder: 13,
        sidebarOrderByTheme: {
            [Theme.Rocketbet]: 3
        },
        href: GameCategory.LiveCasino
    },
    {
        name: Verbiage.new_games,
        icon: 'NewGamesIcon',
        sidebarOrder: 14,
        sidebarOrderByTheme: {
            [Theme.Rocketbet]: 2
        },
        href: GameCategory.NewGames
    },
    {
        name: Verbiage.game_shows,
        icon: 'GameShowsIcon',
        sidebarOrder: 15,
        sidebarOrderByTheme: {
            [Theme.Rocketbet]: 4
        },
        href: GameCategory.GameShows
    },
    {
        name: Verbiage.feature_buy_in,
        icon: 'FeatureBuyInIcon',
        sidebarOrder: 16,
        href: GameCategory.FeatureBuyIn
    },
    {
        name: Verbiage.providers,
        icon: 'ProviderIcon',
        sidebarOrder: 17,
        sidebarOrderByTheme: {
            [Theme.Rocketbet]: 7
        },
        href: GameCategory.Providers
    },
    {
        name: Verbiage.recently_played,
        icon: 'RecentlyPlayedIcon',
        sidebarOrder: 18,
        sidebarOrderByTheme: {
            [Theme.Rocketbet]: 6
        },
        href: GameCategory.RecentlyPlayed
    },
    {
        name: Verbiage.favorites,
        icon: 'FavoritesUserIcon',
        sidebarOrder: 19,
        sidebarOrderByTheme: {
            [Theme.Rocketbet]: 8
        },
        href: GameCategory.Favorites
    }
];
export const getSections = (featureSet, isAuthenticated, includeOnlySearch = false) => {
    const theme = get(stateTheme);
    return sections
        .filter((item) => {
        if (item.onlySearch && !includeOnlySearch)
            return false;
        const matchesFeature = !item.rel || item.rel === featureSet;
        const matchesAuth = !item.authed || (item.authed && isAuthenticated);
        const matchesTheme = !item.themes || item.themes.includes(theme);
        return matchesFeature && matchesAuth && matchesTheme;
    })
        .sort((a, b) => {
        const ao = a.sidebarOrderByTheme?.[theme] ?? a.sidebarOrder ?? 9999;
        const bo = b.sidebarOrderByTheme?.[theme] ?? b.sidebarOrder ?? 9999;
        return ao - bo;
    });
};
